/**
 * Owner: Masa Bayu
 * File: google-client-ids.ts
 * Date:Time: 2026-10-22 10:22
 * Description: Google OAuth client IDs for qxread sign-in (§413).
 */

/** QXRead GCP project "qxread" · Web (GIS) client · origins qxread.com + localhost:5173. */
export const QXREAD_GOOGLE_GIS_CLIENT_ID =
  '334701570162-50cqfnhhd21968f9t3g1u960u4736g7l.apps.googleusercontent.com';
